function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 230.47,
  y1: -107.85,
  x2: 257.65,
  y2: 182.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 164.91,
  y1: 144.67,
  x2: 196.63,
  y2: 144.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#010101",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#010101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 185.22,
  y1: 206.87,
  x2: 66.42,
  y2: 293.75,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 173.2,
  y1: 349.7,
  x2: 173.2,
  y2: 197.38,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 260.94,
  y1: 116.62,
  x2: 263.85,
  y2: 147.69,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 153.01,
  y1: 188.74,
  x2: 152.83,
  y2: 243.26,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 369.31,
  y1: 335.34,
  x2: 386.97,
  y2: 335.34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e4c5d5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#e9d3cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#efe8ca"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 386.23,
  y1: 335.1,
  x2: 400.52,
  y2: 335.1,
  xlinkHref: "#linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 365.48,
  y1: 163.76,
  x2: 382.5,
  y2: 163.76,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 398.03,
  y1: 204.55,
  x2: 355.49,
  y2: 343.99,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 374.29,
  y1: 167.66,
  x2: 395.15,
  y2: 167.66,
  xlinkHref: "#linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 383.49,
  y1: 162.9,
  x2: 423.4,
  y2: 138.78,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#010101",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#010101",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#010101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 358.97,
  y1: 218.12,
  x2: 380.59,
  y2: 218.12,
  xlinkHref: "#linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 106.81,
  y1: 253.09,
  x2: 93.4,
  y2: 280.8,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 124.05,
  y1: 272.47,
  x2: 79.71,
  y2: 284.99,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 116.46,
  y1: 247.59,
  x2: 98.49,
  y2: 340.11,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 90.69,
  y1: 274.78,
  x2: 108.38,
  y2: 321.08,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 98.94,
  y1: 269.21,
  x2: 71.32,
  y2: 279.27,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 95.27,
  y1: 234.85,
  x2: 75.24,
  y2: 462.97,
  xlinkHref: "#linear-gradient-2"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 132.98,
  y: 52.26,
  width: 242.42,
  height: 158.04,
  rx: 25.38,
  fill: "#33c1ea"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 131.64,
  y: 52.26,
  width: 242.42,
  height: 158.04,
  rx: 25.38,
  fill: "url(#linear-gradient)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M144.58,201.18c-1.07,2.69-2.16,5.54-1.66,8.39a14.44,14.44,0,0,0,2.19,5,99.35,99.35,0,0,0,10.29,13.95,8.39,8.39,0,0,0,3.95,2.94,152.89,152.89,0,0,0,1.05-32,6,6,0,0,0-.65-2.77,6.25,6.25,0,0,0-2.89-2.11c-2.65-1.24-5.29-2.69-8-3.69C148.06,191.89,145.4,201.18,144.58,201.18Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#c8a59c"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M254.25,169.57l-11.06-1.81s-1.14-2.35.6-3.15l17.5,3Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M220.48,189.48a19.43,19.43,0,0,0,5.05.07c.65-.26,19.57-15.28,26.82-19a21.7,21.7,0,0,1,11.15-3.25c1.82-.12,4-.06,5,1.49a3.3,3.3,0,0,1-.23,3.48,7.19,7.19,0,0,1-2.82,2.29,18.9,18.9,0,0,1-7.45,2.09,6.49,6.49,0,0,0-2,.3,5.61,5.61,0,0,0-2.09,1.79q-8.05,9.53-16.85,18.37c-3.13,3.14-6.67,6.38-11.08,6.88a15.75,15.75,0,0,1-4.74-.31,33.34,33.34,0,0,1-8.74-3,4.17,4.17,0,0,1-1.55-1.16,3.88,3.88,0,0,1-.57-2.37,12.18,12.18,0,0,1,2.83-7.54C215.53,186.85,217.51,188.83,220.48,189.48Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#c8a59c"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M194.09,152.36a29.3,29.3,0,0,1-.26,6.88c-.45,2.32-1.75,4.78-4,5.38-1.34.35-2.91,0-4,.91-.82.67-1.05,1.8-1.6,2.71a5.7,5.7,0,0,1-4.74,2.42,16.38,16.38,0,0,1-5.42-1.07,2.93,2.93,0,0,1-1.23-.62,3,3,0,0,1-.62-2.08q-.31-8.55-.24-17.12a11.62,11.62,0,0,1,.76-4.84,9.77,9.77,0,0,1,4.58-4.09A28.68,28.68,0,0,1,186,138c2.79-.45,7.43-.19,7.94,3.41a30.65,30.65,0,0,1-.18,3.94C193.81,147.66,194,150,194.09,152.36Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#c8a59c"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M195.78,133.91a5.19,5.19,0,0,1,.56,4.6,8.87,8.87,0,0,1-2.8,3.86,10,10,0,0,0-2,1.92c-1.21,1.81-.63,4.23-1,6.39,0,.17-.1.38-.28.41s-.31-.12-.43-.26a2.4,2.4,0,0,0-4.2,1.84c.14,1.3,1.31,2.37,1.26,3.68a3.82,3.82,0,0,1-.92,2,3.36,3.36,0,0,1-1.53,1.32,3.66,3.66,0,0,1-1.58,0l-10.8-1.25a7.77,7.77,0,0,1-1.79-.35,5.47,5.47,0,0,1-3.13-3.62,17.24,17.24,0,0,1-.52-4.92c0-3-.14-6.16-1.37-8.94a2.44,2.44,0,0,1-.32-1.3,2,2,0,0,1,.43-.82c1.71-2.21,4.31-3.73,5.48-6.26a7.55,7.55,0,0,1,.69-1.36c.9-1.19,2.65-1.21,4.14-1.13l6.67.37c1.53.08,2.72-.49,4.18-.59a7.62,7.62,0,0,1,3.14.68C191.66,131.06,194.48,132.12,195.78,133.91Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M195.78,133.91a5.19,5.19,0,0,1,.56,4.6,8.87,8.87,0,0,1-2.8,3.86,10,10,0,0,0-2,1.92c-1.21,1.81-.63,4.23-1,6.39,0,.17-.1.38-.28.41s-.31-.12-.43-.26a2.4,2.4,0,0,0-4.2,1.84c.14,1.3,1.31,2.37,1.26,3.68a3.82,3.82,0,0,1-.92,2,3.36,3.36,0,0,1-1.53,1.32,3.66,3.66,0,0,1-1.58,0l-10.8-1.25a7.77,7.77,0,0,1-1.79-.35,5.47,5.47,0,0,1-3.13-3.62,17.24,17.24,0,0,1-.52-4.92c0-3-.14-6.16-1.37-8.94a2.44,2.44,0,0,1-.32-1.3,2,2,0,0,1,.43-.82c1.71-2.21,4.31-3.73,5.48-6.26a7.55,7.55,0,0,1,.69-1.36c.9-1.19,2.65-1.21,4.14-1.13l6.67.37c1.53.08,2.72-.49,4.18-.59a7.62,7.62,0,0,1,3.14.68C191.66,131.06,194.48,132.12,195.78,133.91Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-2)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M171.55,167.76c4,.7,8.2.52,12.3.68,6.22.23,12.61,1.33,17.83,4.71a45.63,45.63,0,0,1,5.95,4.89l9,8.31a2.12,2.12,0,0,1,.88,2.25A17.73,17.73,0,0,1,211.59,200a1.38,1.38,0,0,1-.73.41,1.6,1.6,0,0,1-.79-.2l-10-4.64a17.23,17.23,0,0,0,0,5.95c2.57,14.43,0,29.46-1.26,44.06a4.51,4.51,0,0,1-.45,1.92,4.19,4.19,0,0,1-1.66,1.43c-5.63,3.15-12.4,3.28-18.85,3.24-6,0-12.35-.3-17.17-3.8a4.77,4.77,0,0,1-1.43-1.47,5.62,5.62,0,0,1-.46-2.61l-.56-38.05a7.21,7.21,0,0,0-.37-2.66c-.89-2.22-9.17-5.68-10.6-12.47C148.27,184,165.82,168.81,171.55,167.76Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M171.55,167.76c4,.7,8.2.52,12.3.68,6.22.23,12.61,1.33,17.83,4.71a45.63,45.63,0,0,1,5.95,4.89l9,8.31a2.12,2.12,0,0,1,.88,2.25A17.73,17.73,0,0,1,211.59,200a1.38,1.38,0,0,1-.73.41,1.6,1.6,0,0,1-.79-.2l-10-4.64a17.23,17.23,0,0,0,0,5.95c2.57,14.43,0,29.46-1.26,44.06a4.51,4.51,0,0,1-.45,1.92,4.19,4.19,0,0,1-1.66,1.43c-5.63,3.15-12.4,3.28-18.85,3.24-6,0-12.35-.3-17.17-3.8a4.77,4.77,0,0,1-1.43-1.47,5.62,5.62,0,0,1-.46-2.61l-.56-38.05a7.21,7.21,0,0,0-.37-2.66c-.89-2.22-9.17-5.68-10.6-12.47C148.27,184,165.82,168.81,171.55,167.76Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-3)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M198.33,247.46s8.25,44,8.25,49.89-10.72,62.48-10.72,62.48-9.39.54-11.8-2.68L188.62,303,181,279.74l-3.93,30.48-24.94,48.27L139.81,351,164,299s-12.13-25.63-4.73-52.1Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M198.33,247.46s8.25,44,8.25,49.89-10.72,62.48-10.72,62.48-9.39.54-11.8-2.68L188.62,303,181,279.74l-3.93,30.48-24.94,48.27L139.81,351,164,299s-12.13-25.63-4.73-52.1Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-4)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M184.22,375.13a.89.89,0,0,0,.07.43.81.81,0,0,0,.48.34,16.89,16.89,0,0,0,5.54.79q9.09.24,18.2.41c0-2.9-2.5-5.25-5.19-6.33s-5.64-1.26-8.44-2a2.51,2.51,0,0,1-1.48-.82,2.64,2.64,0,0,1-.32-1.39l-.22-5.73a2.58,2.58,0,0,0-.63-1.92,2.54,2.54,0,0,0-.88-.41c-1.11-.33-3.95-1.52-5-.81s-1.05,3.62-1.21,4.82A95,95,0,0,0,184.22,375.13Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M135.54,363.88a1.15,1.15,0,0,0,.22,1.66l8.79,10a2.8,2.8,0,0,0,.84.74,3,3,0,0,0,1.22.23c3.64.15,7.3.14,10.94,0a8.1,8.1,0,0,0-4.21-5.62c-1.37-.7-3-1-4.16-2a9.42,9.42,0,0,1-2.35-3.43A3.65,3.65,0,0,1,147,361l1.81-3a2.62,2.62,0,0,0,.5-2.34,2.52,2.52,0,0,0-1.11-1c-1.26-.74-3-2.25-4.44-2.52s-2,1.08-2.74,2.29C139.25,357.5,137,360.61,135.54,363.88Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M279.43,138.07c-1.94,3.2-6.44,7-12.23,10.06-8.95,4.72-17.6,5.87-19.35,2.55a3.62,3.62,0,0,1,.11-3.12c.8-2,2.82-4.38,5.72-6.71a43.49,43.49,0,0,1,7.2-4.68c5.56-2.94,11-4.5,14.74-4.46Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-5)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M157.83,203.54V185.88s-8.28,3.94-9.71,7.51C148.12,193.39,155.91,202.6,157.83,203.54Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-6)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M372.57,304.57a8.69,8.69,0,0,0,.16,4.89c2.85,12.52,5.52,25.2,5.58,38,0,3.51-.19,7.11-1.58,10.33A19.69,19.69,0,0,1,371,365c-.91.76-2,1.76-1.68,2.9a2.31,2.31,0,0,0,.85,1.15,5.16,5.16,0,0,0,5.55.53,10.37,10.37,0,0,0,2.55-2.22l6.7-7.29a4.09,4.09,0,0,0,.87-1.24,4.47,4.47,0,0,0-.33-2.88c-2.73-8.58.91-17.76,1.37-26.75.42-8.37-1.95-16.6-4.29-24.65a7.14,7.14,0,0,0-1.09-2.49,4.78,4.78,0,0,0-3.92-1.56,13.9,13.9,0,0,0-4.23,1.05",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-7)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M386.34,306.29q1.85,14.47,3.45,29c1.11,10.14,2.12,20.57-.52,30.43-.54,2-1.18,4.42.09,6.1a4,4,0,0,0,5.2.69,6.92,6.92,0,0,0,2.88-4.78,25.53,25.53,0,0,0,0-5.73c-.66-12.23,2.13-24.36,2.88-36.58a52.55,52.55,0,0,0-.64-13.78c-.94-4.6-3.23-11.22-7.54-13.77C386.6,294.56,385.9,302.81,386.34,306.29Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-8)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M366.23,369.49a2.51,2.51,0,0,0-.68,1,1.67,1.67,0,0,0,.94,1.75,4.32,4.32,0,0,0,2.08.35,12.66,12.66,0,0,0,7.63-2.3c2.93-2.27,4.3-6.23,7.49-8.1a.77.77,0,0,1,.34-.14c.88-.11.57,1.6,1.32,2.05s1.36-.57,1.5-1.35a11.57,11.57,0,0,0,0-4.23c-.1-.47-.29-1-.76-1.14s-1.06.49-1.35,1a11.7,11.7,0,0,1-3.65,4.27c-2.85,1.83-5.71.88-8.75,1.56C369.7,364.86,368,367.61,366.23,369.49Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M388.1,372.66a11.34,11.34,0,0,0,.32,3.49,3.83,3.83,0,0,0,2.23,2.56,4.35,4.35,0,0,0,3.91-1,11,11,0,0,0,3.73-5.93,20.85,20.85,0,0,0,.44-7.09c-.08-.95-.31-2.06-1.17-2.47a6.13,6.13,0,0,1-4.6,4.85,3.08,3.08,0,0,1-3.67-1.89C387.92,367,388.14,370.39,388.1,372.66Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M367.4,262.22a127.92,127.92,0,0,0,.31,18.46l1,15.09,1.07,16.46a8.37,8.37,0,0,0,1.1,4.38c1,1.4,2.72,1.67,4.26,1.83a242.57,242.57,0,0,0,26.93,1.33c1.18,0,2.52-.09,3.31-1.13a5.65,5.65,0,0,0,.81-2.84c.52-5.26.62-10.58,1.15-15.84.85-8.6,2.84-17,3.67-25.56s.42-17.76-3.21-25.36a6.08,6.08,0,0,0-1.68-2.37,5.2,5.2,0,0,0-2.64-.8,203.78,203.78,0,0,0-25.29-1.15c-1.47,0-4.47-.56-5.76.29-1.13.74-2,3.77-2.51,5.12A46.11,46.11,0,0,0,367.4,262.22Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M370.1,164.45c-1.26,3.75-2.05,7.85-.89,11.63a1.49,1.49,0,0,0,.39.72,1.63,1.63,0,0,0,.59.29l1.55.51a4.18,4.18,0,0,0,2.11.32,1.47,1.47,0,0,0,1.28-1.49l.61,2.18,8.31-.75a1.45,1.45,0,0,0,.77-.23,1.36,1.36,0,0,0,.38-1c.51-5.09.39-10.22.45-15.34,0-2.77.1-5.65-1-8.19s-3.78-4.63-6.51-4.11-4.1,2.66-4.52,5.17C373,157.71,371.25,161.06,370.1,164.45Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M370.1,164.45c-1.26,3.75-2.05,7.85-.89,11.63a1.49,1.49,0,0,0,.39.72,1.63,1.63,0,0,0,.59.29l1.55.51a4.18,4.18,0,0,0,2.11.32,1.47,1.47,0,0,0,1.28-1.49l.61,2.18,8.31-.75a1.45,1.45,0,0,0,.77-.23,1.36,1.36,0,0,0,.38-1c.51-5.09.39-10.22.45-15.34,0-2.77.1-5.65-1-8.19s-3.78-4.63-6.51-4.11-4.1,2.66-4.52,5.17C373,157.71,371.25,161.06,370.1,164.45Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-9)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M411,189.21c1.85,3.84,2.09,8.23,2.29,12.49.42,8.54,3.18,17.84-.4,25.61-4.87,10.61,5.09,16.25-2.12,24.77-1.07,1.26-38.66,3.86-41.7-2.75-1.13-2.44,1.91-11.09,1.68-13.77-1.22-14.11-2.38-28.72,2.3-42.08a21.29,21.29,0,0,1,4.66-8.18C388.23,174.87,404.35,175.25,411,189.21Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M411,189.21c1.85,3.84,2.09,8.23,2.29,12.49.42,8.54,3.18,17.84-.4,25.61-4.87,10.61,5.09,16.25-2.12,24.77-1.07,1.26-38.66,3.86-41.7-2.75-1.13-2.44,1.91-11.09,1.68-13.77-1.22-14.11-2.38-28.72,2.3-42.08a21.29,21.29,0,0,1,4.66-8.18C388.23,174.87,404.35,175.25,411,189.21Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-10)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M374.57,164.55a20.21,20.21,0,0,0,0,6.4,7.47,7.47,0,0,0,3.47,5.16,19.16,19.16,0,0,0,3.81,1.19,2,2,0,0,1,1,.5,1.73,1.73,0,0,1,.38.78,17.23,17.23,0,0,1,.16,4.25,4.54,4.54,0,0,0,1.58,3.79,3.53,3.53,0,0,0,3.15.23,7.51,7.51,0,0,0,2.66-1.88,9.47,9.47,0,0,0,1.33-1.63,11.05,11.05,0,0,0,1.21-6.07c0-2.78-.28-5.56-.3-8.34,0-4.92,2.35-7.85,2.19-12.76,0-.86-1.81-3.73-2.19-4.5a6.77,6.77,0,0,0-1.41-1.71,7,7,0,0,0-1.88-1.42,6.1,6.1,0,0,0-3.34-.2,29.73,29.73,0,0,0-6.93,1.93,7.21,7.21,0,0,0-2.35,1.42,3.07,3.07,0,0,0-.86,2.45,20.32,20.32,0,0,1-.56,3.33Q375,161,374.57,164.55Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-11)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M374.55,142a15,15,0,0,0-4.48,9.15,8.88,8.88,0,0,0,.15,3.33,3.68,3.68,0,0,0,1.31,2.07,4,4,0,0,0,2.55.59,4.68,4.68,0,0,0,2.7-.85,2.49,2.49,0,0,0,1-2.53l.26,2.5a.81.81,0,0,0,.15.48.88.88,0,0,0,.71.18l5.49-.3a1.27,1.27,0,0,0,1.45-1l1-2.64a5.24,5.24,0,0,0,.81,2.95,2.65,2.65,0,0,0,3.38.56c-.05,7-.15,14.25-3.16,20.56a5.08,5.08,0,0,0,4.27,1.88,6.21,6.21,0,0,0,3.34-.76,3.3,3.3,0,0,0,1.68-2.84l-.12,1.75a.65.65,0,0,0,.1.48.66.66,0,0,0,.52.12l5.6-.4a1.35,1.35,0,0,0,1.44-1,51.67,51.67,0,0,0,3.86-9.11c1.44-5.08,1.31-10.47.82-15.72a17.49,17.49,0,0,0-.86-4.49c-1.61-4.27-6.18-6.76-10.66-7.59s-8.94-.21-13.41-.61A12.29,12.29,0,0,0,374.55,142Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#606161"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M374.55,142a15,15,0,0,0-4.48,9.15,8.88,8.88,0,0,0,.15,3.33,3.68,3.68,0,0,0,1.31,2.07,4,4,0,0,0,2.55.59,4.68,4.68,0,0,0,2.7-.85,2.49,2.49,0,0,0,1-2.53l.26,2.5a.81.81,0,0,0,.15.48.88.88,0,0,0,.71.18l5.49-.3a1.27,1.27,0,0,0,1.45-1l1-2.64a5.24,5.24,0,0,0,.81,2.95,2.65,2.65,0,0,0,3.38.56c-.05,7-.15,14.25-3.16,20.56a5.08,5.08,0,0,0,4.27,1.88,6.21,6.21,0,0,0,3.34-.76,3.3,3.3,0,0,0,1.68-2.84l-.12,1.75a.65.65,0,0,0,.1.48.66.66,0,0,0,.52.12l5.6-.4a1.35,1.35,0,0,0,1.44-1,51.67,51.67,0,0,0,3.86-9.11c1.44-5.08,1.31-10.47.82-15.72a17.49,17.49,0,0,0-.86-4.49c-1.61-4.27-6.18-6.76-10.66-7.59s-8.94-.21-13.41-.61A12.29,12.29,0,0,0,374.55,142Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-12)"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "363.34 173.94 328.59 178.88 317.49 130.49 352.24 125.55 363.34 173.94",
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M420,227.6c0,1.53,0,3.21-1,4.4s-2.79,1.6-4.4,1.78A56.53,56.53,0,0,1,380.89,227a5.46,5.46,0,0,1-2.06-1.68,5.39,5.39,0,0,1-.63-2.69,43.36,43.36,0,0,1,.13-5.7,2.9,2.9,0,0,1,.91-2.25,2.94,2.94,0,0,1,1.88-.32l15.76.78a2.14,2.14,0,0,0,1.52-.3,2,2,0,0,0,.59-1.33c.85-5.08,0-10.3.5-15.43.39-3.72,2.12-10,6.4-11,5-1.17,6.61,5.12,7.89,8.61A101.42,101.42,0,0,1,420,227.6Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M371.76,213.18a10.59,10.59,0,0,0-2-.74,10.19,10.19,0,0,0-1.91-.16c-1.37,0-2.73,0-4.09,0a16,16,0,0,0-3.6.35,1.57,1.57,0,0,0-.9.49,1.46,1.46,0,0,0-.24.82,5.39,5.39,0,0,0,2.77,5,2.13,2.13,0,0,1,1,.8c.11.22.11.49.21.72a1.82,1.82,0,0,0,1,.81,19.75,19.75,0,0,0,6.83,1.72,2.36,2.36,0,0,1,.95.18,6,6,0,0,1,.61.42,3.5,3.5,0,0,0,2.91.23,19.8,19.8,0,0,1,2.89-.83c.82-.1,1.82-.07,2.23-.77a2,2,0,0,0,.11-1.36,22,22,0,0,0-.51-3.44c-.26-.83-.94-1-1.71-1.31L375,214.62C374.1,214.21,372.51,213.85,371.76,213.18Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-13)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M96.13,311A66.34,66.34,0,0,0,93,283.85c-1.69-5-4-9.86-5.49-15s-2.18-10.62-.57-15.68,2.77-9.37,5.42-13.95c2.92-5,5.89-10.13,10.08-14.15a55.24,55.24,0,0,0-8.06,42c.85,3.9,2.12,7.7,3.09,11.58,2.25,9,2.88,18.33,3,27.61,0,1.78,0,3.7-1.08,5.14S97.2,312.47,96.13,311Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M86.59,229.8S102.9,244.73,102,265.4s-3.27,45-2.67,46,10.25,1.06,10.25,1.06a459.37,459.37,0,0,1-.69-46.62C109.79,239.91,86.59,229.8,86.59,229.8Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M86.59,229.8S102.9,244.73,102,265.4s-3.27,45-2.67,46,10.25,1.06,10.25,1.06a459.37,459.37,0,0,1-.69-46.62C109.79,239.91,86.59,229.8,86.59,229.8Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-14)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M136.05,231.57s-19.3,15-23.74,39.65-6.73,41.34-6.73,41.34l11-.46s.15-39.81,8.73-57.88S136.05,231.57,136.05,231.57Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M136.05,231.57s-19.3,15-23.74,39.65-6.73,41.34-6.73,41.34l11-.46s.15-39.81,8.73-57.88S136.05,231.57,136.05,231.57Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-15)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M114.76,217s7,25.88,2.61,38.74-6,57.18-6,57.18l-5.82-.38s.53-46.93,2.6-53.82S116.52,234.78,114.76,217Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M114.76,217s7,25.88,2.61,38.74-6,57.18-6,57.18l-5.82-.38s.53-46.93,2.6-53.82S116.52,234.78,114.76,217Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-16)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M67.91,254.07s28-4.44,35.22,14.39,0,43.91,0,43.91l-3.82-.95s3.59-39.82-18-50.84Z",
  transform: "translate(-12.99 -66.59)",
  fill: "#33c1ea"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M67.91,254.07s28-4.44,35.22,14.39,0,43.91,0,43.91l-3.82-.95s3.59-39.82-18-50.84Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-17)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M96.13,311A66.34,66.34,0,0,0,93,283.85c-1.69-5-4-9.86-5.49-15s-2.18-10.62-.57-15.68,2.77-9.37,5.42-13.95c2.92-5,5.89-10.13,10.08-14.15a55.24,55.24,0,0,0-8.06,42c.85,3.9,2.12,7.7,3.09,11.58,2.25,9,2.88,18.33,3,27.61,0,1.78,0,3.7-1.08,5.14S97.2,312.47,96.13,311Z",
  transform: "translate(-12.99 -66.59)",
  fill: "url(#linear-gradient-18)"
});

var _ref44 = /*#__PURE__*/React.createElement("polygon", {
  points: "76.2 242.75 112.95 242.75 105.6 299.71 82.94 299.71 76.2 242.75",
  fill: "#33c1ea"
});

var _ref45 = /*#__PURE__*/React.createElement("polygon", {
  points: "76.2 242.75 112.95 242.75 105.6 299.71 82.94 299.71 76.2 242.75",
  fill: "url(#linear-gradient-19)"
});

function SvgNewAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 536 360.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StartUP 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M158.42,83.94a130.37,130.37,0,0,0-14.86-2.16,106.07,106.07,0,0,0-68.2,18.15c-33.49,23-48,65.3-56.39,103.38-9.47,42.75-8.47,88.62,8.76,129.34C51.29,388.34,109,431.17,169.3,426.54c26.25-2,51.24-12.39,77.41-15.35,30.06-3.4,60.26,3.08,90.45,5a302.14,302.14,0,0,0,133.33-21.88c24.86-10.19,49.25-24.57,63.78-47.17C556,313.31,551,268.53,536.66,230.94c-7.61-20-17.54-39.06-27-58.26s-15.72-39.76-24.52-59c-14.74-32.22-55.39-51.24-89.53-46.35-30.09,4.3-55.93,23.94-85.54,30.8-14.06,3.25-28.63,3.54-43.06,3.2-24.48-.57-49-2.91-72.83-8.54C182.23,90,170.43,86.33,158.42,83.94Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.57,370.53c-5.49.28-11.47.76-15.45,4.54A593.33,593.33,0,0,0,457.28,373c-3-5.57-10.57-6.38-16.92-6.52-18-.4-39.11-5.45-56.85-2.52C365.16,367,347.19,370.53,328.57,370.53Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,370.69c-3,.07-7.19,1.45-6.57,4.42.43,2,2.91,2.76,5,3.08,50.21,7.92,101.63,7.08,151.91-.45-.63-3.16-12.79-1.87-18-2.74-6.4-1.07-12.8-2.19-19.16-3.5a135.63,135.63,0,0,0-32.85-2.78Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "M252.08,225.12a27.74,27.74,0,1,1-29.19-27.62,10.69,10.69,0,0,1,1.49-.07A27.7,27.7,0,0,1,252.08,225.12Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,150.53c-.22.76-3.77,1.71-4.68,2.29a17.74,17.74,0,0,0-4.08,4c-2.17,2.86-3.88,6.06-6.44,8.58a9.92,9.92,0,0,0-1.94,2.2c-.69,1.19-.69,2.63-1.1,3.93a6.93,6.93,0,0,1-6.1,4.76,6.87,6.87,0,0,1-5.3,12,21.21,21.21,0,0,1,2.4,9.14,27.65,27.65,0,0,0-20.41,10.63,6.41,6.41,0,0,1-4.16-3.08c-2.21,2-5.75.72-8.07-1.11-8.39-6.51-10.75-19.58-5.15-28.61,2.75-4.5,8.65-8,13.15-5.3,1.18-1.9,3.84-2.47,6-1.9A15.73,15.73,0,0,1,210,171.6c-.42-3.32,2.4-6.52,5.68-7.17a10.07,10.07,0,0,1,9,3.51c-.92-1.07,17.25-16.72,19.16-18C244.91,149.27,251.39,146.22,250.13,150.53Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.45,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,192c-6.93,8.92-15.69,18.29-27,18.49-2.07,0-4.23-.24-6.15.56-3.69,1.54-4.76,6.16-5.34,10.13-1.45,10-2.89,20.15-1,30,1.47,7.68,4.93,15.16,4.2,22.94-.14,1.43-.53,3-1.76,3.76a5.21,5.21,0,0,1-3.11.37l-17.32-1.52a7.45,7.45,0,0,1-4.08-1.17,7.16,7.16,0,0,1-2-3.41c-7-19.91-5.32-41.66-3.58-62.68.38-4.63.78-9.34,2.48-13.67s4.89-8.29,9.29-9.78c10-3.39,19.67,6.92,30.24,7.33,11,.42,18.69-9.26,26.56-15.43,2.63-2.07,9.09-8.28,9.67-1.93C257.52,180.21,248.52,188.81,246,192Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.36,
    cy: 157.55,
    r: 27.71,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, /*#__PURE__*/React.createElement("rect", {
    x: 281.81,
    y: 86.49,
    width: 71.6,
    height: 4.83,
    rx: 2.41,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.01,
    y: 94.8,
    width: 71.6,
    height: 4.83,
    rx: 2.41,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.2,
    y: 103.12,
    width: 71.6,
    height: 4.83,
    rx: 2.41,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.4,
    y: 111.43,
    width: 71.6,
    height: 4.83,
    rx: 2.41,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.33,
    y: 124.84,
    width: 74.28,
    height: 65.43,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.66 147.01 300.67 172.03 324.99 141.64 335.36 156.3 350.02 132.35 350.02 186.69 281.01 186.69 281.01 157.38 285.66 147.01",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.48,201.54c-3.43-3.24-8.71-3.95-13.27-2.76s-8.52,4.05-12,7.22a22.31,22.31,0,0,0-5.29,6.45c-1.63,3.3-1.82,7.12-1.84,10.8a142.27,142.27,0,0,0,2,24.3,4.54,4.54,0,0,0,.75,2.14c1.28,1.59,3.78.85,5.81,1.07,2.46.27,4.47,2.16,5.72,4.3a59.42,59.42,0,0,1,2.88,6.83,26.56,26.56,0,0,0,8.53,10.81c2.7,2,6.67,3.43,9.27,1.28a8.31,8.31,0,0,0,2-3c12.4-27.05,2.2-59.61,11.13-88,.56-1.78,4.64-10.12,2-11.37-2-.9-5.05,4.27-5.91,5.43a75.65,75.65,0,0,0-7,10.92C372.44,189.47,367.11,200.25,368.48,201.54Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _ref17, /*#__PURE__*/React.createElement("path", {
    d: "M253.68,140.85c-2.9,2.33-4.92,4.69-5.72,6.71-2.13-2.52-8-4.42-8-4.42C244.8,139.63,251.85,140.55,253.68,140.85Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34,162s7.84-4,9.26-11.05c0,0-6.66,2.66-9.82,1.44C250.78,152.39,252.88,155.4,251.34,162Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,138l0,0-3.81-6.36,0,0s6.25-1,7.09.12S279.89,137.5,279.47,138Z",
    transform: "translate(-12.99 -66.59)",
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.82,
    cy: 77.33,
    r: 2.82,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.69,
    cy: 74.01,
    r: 2.22,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.26,
    cy: 71.19,
    r: 2.22,
    fill: "#33c1ea",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAccount);
export default __webpack_public_path__ + "static/media/new_account.705c88e9.svg";
export { ForwardRef as ReactComponent };